
import React from 'react';
import { Button } from "@/components/ui/button";

interface LeadFormActionsProps {
  onClose: () => void;
  isSubmitting: boolean;
  isEditing: boolean;
}

export const LeadFormActions = ({ onClose, isSubmitting, isEditing }: LeadFormActionsProps) => {
  return (
    <div className="flex justify-end gap-2">
      <Button 
        variant="outline" 
        onClick={onClose} 
        type="button" 
        disabled={isSubmitting}
      >
        Cancel
      </Button>
      <Button 
        type="submit" 
        disabled={isSubmitting}
      >
        {isSubmitting ? "Saving..." : isEditing ? "Update Lead" : "Add Lead"}
      </Button>
    </div>
  );
};
